export const UI_SIZES = {
  inputHeight: 35,
  iconButtonSize: 35,
} as const;
